// extracted by mini-css-extract-plugin
export default {"root":"Alert_root__2A4O+","info":"Alert_info__lQ+0B","text":"Alert_text__TS4ep","warning":"Alert_warning__NgwrJ","success":"Alert_success__pvk9G","error":"Alert_error__hSm7C"};